// ====================================================================================
// iframes.module
// ====================================================================================
import { getUcService } from "./usercentrics.module";

const addScript = (src, dataUC) => {
  if (document.querySelector(`[data-usercentrics="${dataUC}"]`)) return;
  let s = document.createElement("script");
  s.setAttribute("data-usercentrics", dataUC);
  s.setAttribute("src", src);
  s.setAttribute("async", "async");
  s.setAttribute("crossorigin", "anonymous");
  document.head.appendChild(s);
};

const removeScript = (dataUC) => {
  if (!document.querySelector(`[data-usercentrics="${dataUC}"]`)) return;
  document.querySelector(`[data-usercentrics="${dataUC}"]`).remove();
};

export const init = () => {
  let facebook = document.querySelectorAll("[data-hl='r5-Z_erQ0']");
  let twitter = document.querySelectorAll("[data-hl='BJTzqNi_i-m']");
  let instagram = document.querySelectorAll("[data-hl='SyUQ54odobQ']");
  let youtube = document.querySelectorAll("[data-hl='BJz7qNsdj-7']");
  let dataWrapper = document.querySelectorAll("[data-hl='8Nxb4ZtSa']");
  let gMaps = document.querySelectorAll("[data-hl='S1pcEj_jZX']");
  let vimeo = document.querySelectorAll("[data-hl='HyEX5Nidi-m']");
  let gAnalytics = document.querySelectorAll("[data-hl='HkocEodjb7']");
  let gTagManager = document.querySelectorAll("[data-hl='BJ59EidsWQ']");
  let openStreetMap = document.querySelectorAll("[data-hl='j7Igy6o8D']");

  const checkUsercentrics = (id, elements, dataUC) => {
    if (elements.length > 0) {
      let isAllowed = getUcService(id);
      if (isAllowed) {
        if (id === "r5-Z_erQ0") {
          addScript(
            "https://connect.facebook.net/de_DE/sdk.js#xfbml=1&version=v22.0",
            dataUC
          );
        } else if (id === "BJTzqNi_i-m") {
          addScript("https://platform.twitter.com/widgets.js", dataUC);
        } else if (id === "SyUQ54odobQ") {
          addScript("https://www.instagram.com/embed.js", dataUC);
        } else if (id === "8Nxb4ZtSa") {
          window.addEventListener("message", function (a) {
            if (void 0 !== a.data["datawrapper-height"])
              for (let key in a.data["datawrapper-height"]) {
                let t =
                  document.getElementById(`datawrapper-chart-${key}`) ||
                  document.querySelector(`iframe[src*="${key}"]`);
                t &&
                  (t.style.height = a.data["datawrapper-height"][key] + "px");
              }
          });
        } else if (id === "j7Igy6o8D") {
          openStreetMap.forEach((el) => {
            el.querySelector(".hidden-uc").classList.add("flex-column");
          });
        }
      } else {
        removeScript(dataUC);
      }

      elements.forEach((el) => {
        let shown = el.querySelector(`.shown-uc`);
        let hidden = el.querySelector(`.hidden-uc`);

        if (isAllowed) {
          if (hidden.classList.contains("code")) {
            let code = hidden.dataset.code;
            if (hidden.innerHTML === "") hidden.innerHTML = code;
          }
          if (hidden.classList.contains("template")) {
            let templateContent = hidden.querySelector(".template-content");
            let temp = hidden.getElementsByTagName("template")[0];
            if (templateContent.innerHTML === "") {
              templateContent.innerHTML = temp.innerHTML;
            }
          }
          shown.style.display = "none";
          setTimeout(() => {
            hidden.style.display = "block";
          }, 1000);
        } else {
          if (hidden.classList.contains("code")) {
            hidden.innerHTML = "";
          }
          if (hidden.classList.contains("template")) {
            hidden.querySelector(".template-content").innerHTML = "";
          }
          shown.style.display = "block";
          hidden.style.display = "none";
        }
      });
    }
  };

  document.addEventListener("asuc-updated", function () {
    checkUsercentrics("r5-Z_erQ0", facebook, "Facebook Videos");
    checkUsercentrics("BJTzqNi_i-m", twitter, "Twitter Plugin");
    checkUsercentrics("SyUQ54odobQ", instagram, "Instagram Content");
    checkUsercentrics("BJz7qNsdj-7", youtube, "YouTube Video");
    checkUsercentrics("8Nxb4ZtSa", dataWrapper, "DataWrapper");
    checkUsercentrics("S1pcEj_jZX", gMaps, "Google Maps");
    checkUsercentrics("HyEX5Nidi-m", vimeo, "Vimeo");
    checkUsercentrics("HkocEodjb7", gAnalytics, "Google Analytics");
    checkUsercentrics("BJ59EidsWQ", gTagManager, "Google Tag Manager");
    checkUsercentrics("j7Igy6o8D", openStreetMap, "OpenStreetMap");
  });
};
